import { v4 as uuidv4 } from "uuid";

export const baseURL = "https://ittyadiglobal.legendasoft.org";

export const diviceToken = localStorage.getItem("device_token")

if(!diviceToken) {
    localStorage.setItem("device_token", uuidv4())
}
